import { useThemePerformanceReturn } from '../hooks/useThemePerformanceReturn';
import {
  Horizon,
  HorizonItem,
  HorizonItemProps,
} from '../horizon-item/HorizonItem';
import styles from './HorizonSelector.module.scss';

export const HorizonSelector = ({
  horizons,
  selectedHorizon,
  handleHorizonChange,
  horizonToIndexMap,
  benchmarkTags,
  themeId,
  horizonLabelOverrides,
}: {
  horizons: Horizon[];
  selectedHorizon: Horizon;
  handleHorizonChange: (horizon: Horizon) => void;
  horizonToIndexMap: Map<string, number>;
  benchmarkTags?: string[];
  themeId: string;
  horizonLabelOverrides?: HorizonItemProps['horizonLabelOverrides'];
}) => {
  const { isLoading, getReturnForHorizon, getReturnValue } =
    useThemePerformanceReturn({ themeId });

  return (
    <div className={styles.root}>
      {horizons.map(horizon => (
        <HorizonItem
          key={horizon}
          horizonToIndexMap={horizonToIndexMap}
          horizon={horizon}
          isSelected={horizon === selectedHorizon}
          benchmarkTags={benchmarkTags}
          onClick={() => handleHorizonChange(horizon)}
          horizonLabelOverrides={horizonLabelOverrides}
          isPerformanceLoading={isLoading}
          horizonReturn={getReturnForHorizon(horizon)}
          getReturnValue={getReturnValue}
        />
      ))}
    </div>
  );
};
